import React, { useEffect, useState } from "react";
import { TextField, Button, Grid, Autocomplete, Box } from "@mui/material";
import {
  createClientOrganization,
  dropdownSubscription,
  fetchSubscriptionList,
  getOrganizations,
  updateOrganization,
  singleImageUpload
} from "../../../API Service/apiService";
import { Calendar } from "../../../Componants/Common/Calender";

import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import { useLocation, useHistory, useNavigate } from "react-router-dom";
import { Constants } from "../../../constants/Constants";
const subscriptionTypes = ["trial", "subscription"];

// import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
// import SuperAdminTabs from "../../../Componants/Common/SuperAdminTabs";

const inventoryManagementOpt = ["Yes", "No"];

const CreateOrganizations = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [orgID, setOrgID] = useState(queryParams.get("orgID"));
  const [editIndex, setEditIndex] = useState(false);
  const [organizationData, setOrganizationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]); // State for subscription plans
  const [formData, setFormData] = useState({
    clientName: "",
    companyName: "",
    mobileNo: "",
    email: "",
    alternateNo: "",
    address: "",
    subscriptionType: "",
    startDate: null,
    endDate: null,
    subscriptionPlan: null,
    noOfLicense: "",
    planPrice: "",
    accessKey: "",
    loginID: "",
    password: "",
    canManageInventory: "",
    image: null,
    inentoryManagement: "",
  });
  const [imageValue, setImageValue] = useState([]);

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await fetchSubscriptionList();
      console.log(response);
      if (response) {
        setSubscriptionPlans(response);
      }
    } catch (error) {
      console.error("Failed to fetch subscription plans:", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Generic handler for updating form fields
  const handleDateChange = (fieldName, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the specific field with the new value
    }));
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    
    },
    setImageValue([])
  );
  };

  const handleSubscriptionTypeChange = (event, newValue) => {
    setFormData({
      ...formData,
      subscriptionType: newValue,
    });
  };

  const handleSubscriptionPlanChange = (event, newValue) => {
    setFormData({
      ...formData,
      subscriptionPlan: newValue ? newValue._id : null, // Store plan ID
    });
  };

  const handleInventoryManagementChange = (event, newValue) => {
    setFormData({
      ...formData,
      canManageInventory: newValue === "Yes",
    });
  };

  // const handleSubmit = async () => {
  //   try {
  //     setLoading(true);
  //     const formDataToSend = new FormData();
  //     const payload = {
  //       ...formData,
  //       startDate: formData.startDate
  //         ? new Date(formData.startDate).toISOString()
  //         : null,
  //       endDate: formData.endDate
  //         ? new Date(formData.endDate).toISOString()
  //         : null,
  //     };

  //     // Append all fields to FormData
  //     Object.keys(formData).forEach((key) => {
  //       if (formData[key] !== null && formData[key] !== undefined) {
  //         if (key === "image") {
  //           // Append file only if it exists
  //           if (formData.image) {
  //             formDataToSend.append("image", formData.image);
  //           }
  //         } else {
  //           formDataToSend.append(key, formData[key]);
  //         }
  //       }
  //     });

  //     // Convert dates to ISO strings before sending
  //     if (formData.startDate) {
  //       formDataToSend.set(
  //         "startDate",
  //         new Date(formData.startDate).toISOString()
  //       );
  //     }
  //     if (formData.endDate) {
  //       formDataToSend.set("endDate", new Date(formData.endDate).toISOString());
  //     }

  //     // Send API request
  //     const response = await createClientOrganization(formDataToSend);
  //     console.log("API Response:", response);
  //     toast(response.message || "Organization Created Successfully!");
  //   } catch (error) {
  //     console.error("Error creating organization:", error);
  //     toast("Failed to create organization. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

 
// const handleSubmit = async () => {
//   try {
//     setLoading(true);
//     let imagePath = [];
    
//     // First upload the image if it exists
//     if (formData.image && imageValue.length === 0) {
//       const imageFormData = new FormData();
//       imageFormData.append('imageType', 'organization');
//       imageFormData.append('image', formData.image);
      
//       const imageResponse = await singleImageUpload(imageFormData);
//       if (imageResponse && imageResponse.data.data.fullPath) {
//         imagePath = imageResponse.data.data.fullPath;
//         setImageValue(imagePath);
//       }
//     }

//     const formDataToSend = new FormData();
    
//     // Append all fields to FormData
//     Object.keys(formData).forEach((key) => {
//       if (formData[key] !== null && formData[key] !== undefined) {
//         if (key === 'image') {
//           // Use the image path from singleImageUpload instead of the file
//           if (imagePath.length > 0) {
//             formDataToSend.append('imagePath', imagePath.length > 0 ? imagePath : imageValue);
//           }
//         } else {
//           formDataToSend.append(key, formData[key]);
//         }
//       }
//     });

//     // Convert dates to ISO strings before sending
//     if (formData.startDate) {
//       formDataToSend.set('startDate', new Date(formData.startDate).toISOString());
//     }
//     if (formData.endDate) {
//       formDataToSend.set('endDate', new Date(formData.endDate).toISOString());
//     }

//     // Send API request to create organization
//     const response = await createClientOrganization(formDataToSend);
//     console.log("API Response:", response);
//     toast(response.message || "Organization Created Successfully!");
//   } catch (error) {
//     console.error("Error creating organization:", error);
//     toast.error("Failed to create organization. Please try again.");
//   } finally {
//     setLoading(false);
//   }
// };

const handleSubmit = async () => {
  try {
    setLoading(true);
    let imagePath = '';   
    // First upload the image if it exists
    if (formData.image && imageValue.length === 0) {
      const imageFormData = new FormData();
      imageFormData.append('imageType', 'organization');
      imageFormData.append('image', formData.image);
      
      const imageResponse = await singleImageUpload(imageFormData);
      if (imageResponse.data.status === "success" && imageResponse.data.data.fullPath) {
        imagePath = imageResponse.data.data.fullPath;
        setImageValue(imagePath);
      }
      else{
        toast.error("Failed to upload image");
        return;
      }
    }


    // Prepare payload for organization creation
    const payload = {
      clientName: formData.clientName,
      companyName: formData.companyName,
      mobileNo: formData.mobileNo,
      email: formData.email,
      alternateNo: formData.alternateNo,
      address: formData.address,
      subscriptionType: formData.subscriptionType,
      startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
      endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
      subscriptionPlan: formData.subscriptionPlan,
      noOfLicense: formData.noOfLicense,
      planPrice: formData.planPrice,
      accessKey: formData.accessKey,
      loginID: formData.loginID,
      password: formData.password,
      canManageInventory: formData.canManageInventory,
      imagePath: imagePath.length > 0 ? imagePath : imageValue
    };

    // Send API request to create organization
    const response = await createClientOrganization(payload);
    console.log("API Response:", response);
    toast.success(response.message || "Organization Created Successfully!");
    
    // Optional: Clear form or redirect after success
    handleCancel();
  } catch (error) {
    console.error("Error creating organization:", error);
    toast.error("Failed to create organization. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const handleCancel = () => {
    setFormData({
      clientName: "",
      companyName: "",
      mobileNo: "",
      email: "",
      alternateNo: "",
      address: "",
      subscriptionType: "",
      startDate: null,
      endDate: null,
      subscriptionPlan: null,
      noOfLicense: "",
      planPrice: "",
      accessKey: "",
      loginID: "",
      password: "",
      canManageInventory: "",
      image: null,
    });
    setEditIndex(false);
    setOrgID(null); // Clear state
    setSubscriptionPlans([]);

    navigate(location.pathname, { replace: true });
  };

  const handleEdit = async () => {
    try {
      setEditIndex(true);
      const params = { organizationId: orgID };
      const orgData = await getOrganizations(params);
      console.log("Organization Data:", orgData);
      if (orgData) {
        const org = orgData.data.organizations[0];
        console.log(org);
        setFormData({
          clientName: org.clientName || "",
          companyName: org.companyName || "",
          mobileNo: org.mobileNo || "",
          email: org.email || "",
          alternateNo: org.alternateNo || "",
          address: org.address || "",
          subscriptionType: org.subscriptionType || "trial",
          startDate: org.trialStartDate || org.subscriptionStartDate || null,
          endDate: org.trialEndDate || org.subscriptionEndDate || null,
          subscriptionPlan: org.subscriptionPlan || null,
          noOfLicense: org.noOfLicense || "",
          planPrice: org.planPrice || "",
          accessKey: org.accessKey || "",
          loginID: org.loginID || "",
          password: org.password || "",
          canManageInventory: org.canManageInventory || false,
          image: null,
        });
      }
    } catch (error) {
      console.error("Error in handleEdit:", error);
      toast.error("Failed to load organization data for editing.");
    }
  };

  const handleUpdate = async () => {
    try {
      const body = {
        ...formData,
        organizationId: orgID,
      };
      const response = await updateOrganization(body);
      toast.success(response.message);
      handleCancel();
      setTimeout(() => {
        navigate('/createorganizationsview');
      }, 1000);
    } catch (error) {
      console.log(`Error in updating organization`, error);
    }
  };

  useEffect(() => {
    if (orgID) {
      handleEdit();
    }
  }, [orgID]);
  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);

  return (
    <>
      <HeaderNavigation value={"Create Client/Organization"} />
      <Box
        classname="ClientOrganization-container"
        sx={{
          padding: "30px",
          backgroundColor: "#eff3fe",
          margin: "5px",
          borderRadius: "10px",
          paddingBottom: "30px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Client Name"
              name="clientName"
              value={formData.clientName}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Mobile No."
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Alternate No."
              name="alternateNo"
              value={formData.alternateNo}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </Grid>

          {/* Subscription Type */}
          <Grid item xs={6} md={4}>
            <Autocomplete
              sx={{
                width: {
                  xs: "100%", // Full width on extra-small screens
                  sm: "75%", // 75% width on small screens
                  md: "60%", // 60% width on medium screens
                  lg: "50%", // 50% width on large screens
                },
              }}
              options={subscriptionTypes}
              value={formData.subscriptionType}
              onChange={handleSubscriptionTypeChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subscription Type"
                  variant="standard"
                />
              )}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <Calendar
              value={formData.startDate}
              handleChange={handleDateChange}
              fieldName="startDate"
              label="Select Start Date"
            />
          </Grid>

          {/* Conditionally Rendered Fields */}
          {formData.subscriptionType === "subscription" && (
            <>
              <Grid item xs={6} md={4}>
                <Calendar
                  value={formData.endDate}
                  handleChange={handleDateChange}
                  fieldName="endDate"
                  label="Select End Date"
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <Autocomplete
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "75%",
                      md: "60%",
                      lg: "50%",
                    },
                  }}
                  options={subscriptionPlans}
                  getOptionLabel={(option) => option.packageName}
                  value={
                    subscriptionPlans.find(
                      (plan) => plan._id === formData.subscriptionPlan
                    ) || null
                  }
                  onChange={handleSubscriptionPlanChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subscription Plan"
                      variant="standard"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  variant="standard"
                  width="fit-content"
                  label="No. of Licenses"
                  name="noOfLicense"
                  value={formData.noOfLicense}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  variant="standard"
                  width="fit-content"
                  label="Plan Price"
                  name="planPrice"
                  value={formData.planPrice}
                  onChange={handleInputChange}
                />
              </Grid>
            </>
          )}

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Access Key"
              name="accessKey"
              value={formData.accessKey}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Login ID"
              name="loginID"
              value={formData.loginID}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              width="fit-content"
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <Autocomplete
              sx={{
                width: {
                  xs: "100%",
                  sm: "75%",
                  md: "60%",
                  lg: "50%",
                },
              }}
              options={inventoryManagementOpt}
              value={formData.canManageInventory ? "Yes" : "No"}
              onChange={handleInventoryManagementChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Inventory Management"
                  variant="standard"
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="textinput-ClientOrganization">
              <input
                style={{ border: 0, paddingTop: "20px" }}
                type="file"
                onChange={handleFileChange}
              />
            </div>
          </Grid>

          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button
              variant="contained"
              className="action-button"
              size="large"
              style={{ backgroundColor: "#32499F", color: "white" }}
              // onClick={handleSubmit}
              onClick={editIndex ? handleUpdate : handleSubmit}
            >
              {!editIndex ? Constants.create : Constants.update}
            </Button>
            <Button
              variant="contained"
              className="action-button"
              size="large"
              style={{
                backgroundColor: "#32499F",
                color: "white",
                marginLeft: "10px",
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Toaster />
      {loading && <Loader />}
    </>
  );
};

export default CreateOrganizations;
